@layer module {
.currency-badge-wrapper {
            border-width: 1px;
            border-style: solid;
            width: 100%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
    }
} // layer module










@layer app {
.currency-badge-wrapper {
            border-radius: $size-42;
            max-width: $size-85;
            padding: $size-6;
            gap: $size-6;
    }

.currency-badge-wrapper {
            background-color: var(--banky-white);
            border-color: var(--border-neutral-light);
    }

.currency-badge-wrapper.selected {
            background-color: var(--currency-badge-success-background);
            border-color: var(--currency-badge-success-border);
    }

.currency-badge-wrapper .currency-name {
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 400;
            line-height: $size-15;
    }
} // layer app
